module.exports = __webpack_public_path__ + "static/media/Finnovex-Saudi-Arabia-2024.f4943745.png";